export { fixedPageDataFetcher } from "./FixedPage.fetcher";
export { FixedPageTemplate } from "./FixedPage.Template";
